import React from 'react';
import { ProfileData } from './Components/ProfileData';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import ProtectedRoute from './Components/Auth/ProtectedRoute';
import Login from './Components/Auth/Login';
import NCD from './Components/Claims/NCD/NCD';
import SearchForm from './Components/Claims/Search/SearchForm';
import NoTouch30daylast7 from './Components/Reports/NoTouch/30daylast7';
import NoTouch45daylast7 from './Components/Reports/NoTouch/45daylast7';
import NoTouchPast30daylast14 from './Components/Reports/NoTouch/Past30daylast14';
import NoTouchPast45daylast14 from './Components/Reports/NoTouch/Past45daylast14';
import ArbUnassigned from './Components/Reports/Arb/Unassigned'; 
import Performance from './Components/Reports/Performance';
import AllCollectors from './Components/Admin/CollectorManagement/AllCollectors';
import AllArbitrators from './Components/Admin/ArbitratorManagement/AllArbitrators';
import AllAIPrompts from './Components/Admin/AIPromptManagement/AllAIPrompts';
import PaymentHistory from './Components/Reports/Executive/PaymentHistory';
import PTP5Days from './Components/Reports/Contribution/PTP5Days';
import CanClosed30Days from './Components/Reports/Executive/CanClosed30Days';
import CollectorNotes from './Components/Reports/CollectorNotes';
import DepositReviewReport from './Components/Reports/Executive/DepositReview';
import PTPReport from './Components/Reports/PTPReport';
// import SharePointIframe from './Components/SharepointIframe';

export default function App() {
  return (
    <Routes>
      <Route 
        exact 
        path='/' 
        element={<ProtectedRoute><SearchForm /></ProtectedRoute>} 
      />
      <Route 
        path='/openclaims' 
        element={<ProtectedRoute><SearchForm /></ProtectedRoute>} 
      />
      <Route 
        path='/claims/NCD' 
        element={<ProtectedRoute><NCD /></ProtectedRoute>} 
      />
      <Route 
        path='/claims/OpenClaims' 
        element={<ProtectedRoute><SearchForm /></ProtectedRoute>} 
      />
      <Route
        path='/communications/:phone_number'
        element={<ProtectedRoute><SearchForm /></ProtectedRoute>}
      />
      <Route
        path='/Reports/Arb/Unassigned'
        element={<ProtectedRoute><ArbUnassigned/></ProtectedRoute>}
      />
      <Route
        path='/Reports/NoTouch/30daylast7'
        element={<ProtectedRoute><NoTouch30daylast7/></ProtectedRoute>}
      />
      <Route
        path='/Reports/NoTouch/45daylast7'
        element={<ProtectedRoute><NoTouch45daylast7/></ProtectedRoute>}
      />
      <Route
        path='/Reports/NoTouch/Past30daylast14'
        element={<ProtectedRoute><NoTouchPast30daylast14/></ProtectedRoute>}
      />
      <Route
        path='/Reports/NoTouch/Past45daylast14'
        element={<ProtectedRoute><NoTouchPast45daylast14/></ProtectedRoute>}
      />
      <Route
        path='/Reports/Performance'
        element={<ProtectedRoute><Performance/></ProtectedRoute>}
      />
      <Route 
        path='/login' 
        element={<Login />} 
      />
      <Route
      path='/admin/collectors'
      element={<ProtectedRoute><AllCollectors /></ProtectedRoute>}
      />
      <Route 
        path='/admin/arbitrators' 
        element={<ProtectedRoute><AllArbitrators /></ProtectedRoute>}
      />
      <Route 
        path='/admin/ai-prompts' 
        element={<ProtectedRoute><AllAIPrompts /></ProtectedRoute>}
      />
      <Route 
        path='/profile' 
        element={<ProtectedRoute><ProfileData /></ProtectedRoute>} 
      />
      <Route 
        path='/Reports/Executive/PaymentHistory' 
        element={<ProtectedRoute><PaymentHistory /></ProtectedRoute>}
        />
      <Route
        path='/Reports/Executive/CanClosed30Days'
        element={<ProtectedRoute><CanClosed30Days /></ProtectedRoute>}
      />
      <Route
      path='/Reports/CollectorNotes'
      element={<ProtectedRoute><CollectorNotes /></ProtectedRoute>}
      />
      <Route
      path='/reports/contribution/ptp5days'
      element={<ProtectedRoute><PTP5Days /></ProtectedRoute>}
      />
      <Route
      path='/Reports/Executive/DepositReview'
      element={<ProtectedRoute><DepositReviewReport /></ProtectedRoute>}
      />
      <Route
      path='/Reports/PTPReport'
      element={<ProtectedRoute><PTPReport /></ProtectedRoute>}
      />
    </Routes>
  );
}
